import { Appliance } from '@common/util-models';
import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { DeviceCategoryTypesRecord } from '@sky/util-models';

import { appliancesAdapter, AppliancesState } from './appliances.reducer';

import { CatalogState } from '../catalog.reducer';
import { getCatalogState } from '../catalog.selectors';

const { selectAll: selectAppliances, selectEntities: selectApplianceEntities } =
  appliancesAdapter.getSelectors();

export const getAppliancesState = createSelector(
  getCatalogState,
  (state: CatalogState) => state?.appliances
);

export const getAppliancesLoaded = createSelector(
  getAppliancesState,
  (state: AppliancesState) => state.remoteState
);

export const getApplianceEntities = createSelector(
  getAppliancesState,
  (state: AppliancesState): Dictionary<Appliance> =>
    selectApplianceEntities(state)
);

export const getAllAppliances = createSelector(
  getAppliancesState,
  (state: AppliancesState): Appliance[] => selectAppliances(state)
);

export const getSelectedSkyBox = createSelector(
  getAppliancesState,
  (state: AppliancesState) => state.selectedSkyBox
);

// TODO: remove hardcoded QK values when API supports 'baseCategory' property
export const getAppliances = createSelector(
  getAllAppliances,
  (appliances): Appliance[] =>
    // change
    appliances.filter(
      (item: Appliance) => item.code !== 'QK' && item.code !== 'VIRTUAL'
    )
);

// TODO: remove hardcoded QK values when API supports 'baseCategory' property
export const getBaseAppliances = createSelector(
  getAllAppliances,
  (appliances): Appliance[] =>
    appliances.filter(
      (item: Appliance) => item.code === 'QK' || item.code === 'VIRTUAL'
    )
);

export const getApplianceCategories = createSelector(
  getAppliances,
  (appliances): string[] => {
    const categories = appliances
      .map((item: Appliance) => item.category)
      .filter(Boolean) as string[];
    return [...new Set(categories)];
  }
);

export const getApplianceCategoryTypes = createSelector(
  getAppliances,
  (appliances) =>
    appliances.reduce((prev, curr) => {
      if (curr.category) {
        prev[curr.category] = prev[curr.category]
          ? [
              ...prev[curr.category],
              { name: curr.description, code: curr.code },
            ]
          : [{ name: curr.description, code: curr.code }];
      }
      return prev;
    }, {} as DeviceCategoryTypesRecord)
);

export const getCategoryByApplianceCode = (props: { applianceCode: string }) =>
  createSelector(
    getApplianceEntities,
    (appliances: Dictionary<Appliance>): string | undefined =>
      appliances[props.applianceCode]?.category
  );

export const getTypeByApplianceCode = (props: { applianceCode: string }) =>
  createSelector(
    getApplianceEntities,
    (appliances: Dictionary<Appliance>): string | undefined =>
      appliances[props.applianceCode]?.description
  );

export const getApplianceByCode = (props: { applianceCode: string }) =>
  createSelector(
    getApplianceEntities,
    (appliances: Dictionary<Appliance>): Appliance | undefined =>
      appliances[props.applianceCode]
  );

export const getApplianceByLTCode = (props: { applianceLTCode: string }) =>
  createSelector(
    getAllAppliances,
    (appliances: Appliance[]): Appliance | undefined =>
      appliances.find((item) => item.applianceCodeLt === props.applianceLTCode)
  );
